import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { MonUIRouterTransitionService } from '@monsido/services/ui-router-transition-service/ui-router-transition-service';

import { StateService, UIRouterGlobals } from '@uirouter/angular';
import { TransitionService } from '@uirouter/core';

@Injectable()
export class ParamService {

    private prevParams: Record<string, string> = {};

    constructor (
        private readonly state: StateService,
        private readonly uiRouterGlobals: UIRouterGlobals,
        private readonly monUiRouterTransitionService: MonUIRouterTransitionService,
        private readonly transitionService: TransitionService,
    ) {}

    setParams (params: Params): void {
        Object.keys(params).forEach((key) => {
            this.uiRouterGlobals.params[key] = params[key];
        });
        const newParams = {
            ...this.uiRouterGlobals.params,
            ...params,
        };

        this.monUiRouterTransitionService.onTransitionFinished(() => {
            this.state.transitionTo(this.uiRouterGlobals.current, newParams, {
                reload: false,
                inherit: false,
                notify: false,
            });
        });

        this.prevParams = newParams;
        // this.uiRouterGlobals.params
    }

    getPrevParam (): Record<string, string> {
        return this.prevParams;
    }

    getParams (): Record<string, string> {
        return this.uiRouterGlobals.params;
    }

    updateParams (params: Params): void {
        this.monUiRouterTransitionService.onTransitionFinished(() => {
            this.state.transitionTo(
                this.uiRouterGlobals.current,
                {
                    ...this.uiRouterGlobals.params,
                    ...params,
                },
                {
                    reload: false,
                });
        });
    }

    subscribeParamsChangeOnCurrentState (callback: (params: Params) => void): Function {
        const retained = this.uiRouterGlobals.current.name ?? '';
        return this.transitionService.onRetain({
            retained,
        }, (transition) => {
            callback(transition.params());
        });
    }

    returnPrevParam () {
        return this.prevParams;
    }
}
